function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, cloneElement } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
// import { ReactNodeArray } from 'prop-types';

const PixelBreadcrumbs = _ref => {
  let {
    children,
    variant,
    ...restProps
  } = _ref;
  const color = "text.primary";
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, _extends({
    "aria-label": "breadcrumb"
  }, restProps), Children.map(children, (child, i) => {
    const childrenLength = Children.count(children);
    if (variant === 'primaryLink') {
      return /*#__PURE__*/cloneElement(child, {
        variant
      });
    }
    if (i === childrenLength - 1) {
      return /*#__PURE__*/cloneElement(child, {
        color
      });
    }
    return /*#__PURE__*/cloneElement(child, {});
  })));
};
export default PixelBreadcrumbs;